import { render, staticRenderFns } from "./ReportFarmerConnectedSummaries.vue?vue&type=template&id=4e5f9cda&"
import script from "./ReportFarmerConnectedSummaries.vue?vue&type=script&lang=js&"
export * from "./ReportFarmerConnectedSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports